module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_1000.817ecd2b.png";